// fork overlay: fork-owned extension of OSS v4.15.1 (blob:ae1019dab45bd35e)
//
// Mirrors app/javascript/dashboard/i18n/locale/en/index.js shape (43 OSS sibling
// imports + flat-spread export). Adds ./fork.json as the 44th source, deep-merged
// into inboxMgmt to land INBOX_MGMT.* fork-new keys without touching OSS JSON.
//
// WHY fork-owned: preserve-OSS invariant forbids editing OSS en/index.js or
// inboxMgmt.json. Vite fork overlay (fork/lib/vite_fork_overlay.ts) redirects
// `app/javascript/dashboard/i18n/locale/en/index.js` → this file at build time.
//
// WHY alias-form OSS imports: Relative `./foo.json` from this fork dir would
// resolve into fork/ (where OSS siblings don't exist). Alias `dashboard/...`
// expands through vite.config aliases to the OSS path; fork-overlay plugin then
// checks for a fork override and falls through to OSS when none exists.
//
// WHY deep-merge not shallow: Object-spread at INBOX_MGMT.ADD.WHATSAPP.PROVIDERS
// would wipe the OSS Twilio/360Dialog/WhatsApp Cloud tiles. See RESEARCH Pitfall #1.
import advancedFilters from 'dashboard/i18n/locale/en/advancedFilters.json';
import agentBots from 'dashboard/i18n/locale/en/agentBots.json';
import agentMgmt from 'dashboard/i18n/locale/en/agentMgmt.json';
import attributesMgmt from 'dashboard/i18n/locale/en/attributesMgmt.json';
import auditLogs from 'dashboard/i18n/locale/en/auditLogs.json';
import automation from 'dashboard/i18n/locale/en/automation.json';
import bulkActions from 'dashboard/i18n/locale/en/bulkActions.json';
import campaign from 'dashboard/i18n/locale/en/campaign.json';
import cannedMgmt from 'dashboard/i18n/locale/en/cannedMgmt.json';
import chatlist from 'dashboard/i18n/locale/en/chatlist.json';
import companies from 'dashboard/i18n/locale/en/companies.json';
import components from 'dashboard/i18n/locale/en/components.json';
import contact from 'dashboard/i18n/locale/en/contact.json';
import contactFilters from 'dashboard/i18n/locale/en/contactFilters.json';
import conversation from 'dashboard/i18n/locale/en/conversation.json';
import csatMgmt from 'dashboard/i18n/locale/en/csatMgmt.json';
import customRole from 'dashboard/i18n/locale/en/customRole.json';
import datePicker from 'dashboard/i18n/locale/en/datePicker.json';
import emoji from 'dashboard/i18n/locale/en/emoji.json';
import general from 'dashboard/i18n/locale/en/general.json';
import generalSettings from 'dashboard/i18n/locale/en/generalSettings.json';
import helpCenter from 'dashboard/i18n/locale/en/helpCenter.json';
import inbox from 'dashboard/i18n/locale/en/inbox.json';
import inboxMgmt from 'dashboard/i18n/locale/en/inboxMgmt.json';
import integrationApps from 'dashboard/i18n/locale/en/integrationApps.json';
import integrations from 'dashboard/i18n/locale/en/integrations.json';
import labelsMgmt from 'dashboard/i18n/locale/en/labelsMgmt.json';
import login from 'dashboard/i18n/locale/en/login.json';
import macros from 'dashboard/i18n/locale/en/macros.json';
import report from 'dashboard/i18n/locale/en/report.json';
import resetPassword from 'dashboard/i18n/locale/en/resetPassword.json';
import search from 'dashboard/i18n/locale/en/search.json';
import setNewPassword from 'dashboard/i18n/locale/en/setNewPassword.json';
import settings from 'dashboard/i18n/locale/en/settings.json';
import signup from 'dashboard/i18n/locale/en/signup.json';
import sla from 'dashboard/i18n/locale/en/sla.json';
import snooze from 'dashboard/i18n/locale/en/snooze.json';
import teamsSettings from 'dashboard/i18n/locale/en/teamsSettings.json';
import whatsappTemplates from 'dashboard/i18n/locale/en/whatsappTemplates.json';
import contentTemplates from 'dashboard/i18n/locale/en/contentTemplates.json';
import mfa from 'dashboard/i18n/locale/en/mfa.json';
import onboarding from 'dashboard/i18n/locale/en/onboarding.json';
import sessionLimit from 'dashboard/i18n/locale/en/sessionLimit.json';
import yearInReview from 'dashboard/i18n/locale/en/yearInReview.json';
import forkKeys from './fork.json';
import deepMerge from './deep-merge.js';

// Build the flat OSS locale map first, then deep-merge every fork.json
// namespace (INBOX_MGMT, CAMPAIGN, …) onto it. Merging AFTER the spread means
// each fork top-level key lands in its OSS sibling instead of one hard-coded
// target, so a new fork namespace can no longer clobber an unrelated one
// (e.g. CAMPAIGN must not replace the OSS campaign tree). Arrays are replaced;
// OSS scalars are overwritten only where the fork defines them.
const messages = {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...onboarding,
  ...sessionLimit,
  ...yearInReview,
};

export default deepMerge(messages, forkKeys);
